module.exports = __webpack_public_path__ + "img/CardImage12.0dc0e7e6.png";